import { Link, useLocation } from 'react-router-dom';

const nameMap: Record<string, string> = {
  'register-login': '注册登录',
  'feature-guide': '功能使用',
  faq: '常见问题',
  announcement: '平台公告',
  security: '安全指南',
};

export default function Breadcrumb() {
  const location = useLocation();
  const parts = location.pathname.split('/').filter(Boolean);

  const crumbs = [{ label: '首页', path: '/' }];

  if (parts[0] === 'category' && parts[1]) {
    crumbs.push({ label: nameMap[parts[1]] || parts[1], path: `/category/${parts[1]}` });
  }

  if (parts[0] === 'article') {
    if (parts[1]) {
      crumbs.push({ label: '文章详情', path: location.pathname });
    }
  }

  if (parts[0] === 'about') {
    crumbs.push({ label: '关于我们', path: '/about' });
  }

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 py-3">
      {crumbs.map((crumb, index) => (
        <span key={crumb.path} className="flex items-center gap-1.5">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          {index < crumbs.length - 1 ? (
            <Link to={crumb.path} className="hover:text-primary-500 transition-colors whitespace-nowrap">
              {crumb.label}
            </Link>
          ) : (
            <span className="text-foreground-700 font-medium whitespace-nowrap">{crumb.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}